(function () {
  function isMobile() {
    return window.innerWidth <= 1023;
  }
  function isKiwiModalOpen() {
    return !!window.__pdpKiwiModalOpen;
  }
  function isPdpSidebarOpen() {
    return typeof window.isPdpSidebarOpen === 'function'
      ? window.isPdpSidebarOpen()
      : !!document.querySelector('.pdp-sidebar.is-open');
  }
  function getHeaderOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function shrinkMargin(top, bottom) {
    return (-top) + 'px 0px ' + (-bottom) + 'px 0px';
  }

  function init() {
    if (!document.body.classList.contains('simplified-pdp')) return;

    var bar = document.querySelector('[data-pdp-quick-add-bar]');
    var scrollTarget = document.querySelector('.buy-buttons-with-accessories');
    var mainContent = document.getElementById('MainContent');
    var infoWrapper = document.querySelector('.product-paralax .product__info-wrapper');
    var scrollButton = bar && bar.querySelector('[data-pdp-quick-add-scroll]');
    var swatchOverflowButton = bar && bar.querySelector('.pdp-quick-add-bar__swatches .swatch-mobile-overflow');
    if (!bar || !scrollTarget) return;

    var sectionVisible = false;
    var footerVisible = false;
    var atcObserver = null;
    var atcClearObserver = null;
    var footerRafId = null;
    var applyTimer = null;
    var APPLY_SETTLE_MS = 100;

    function isFullyExpanded() {
      return !infoWrapper || infoWrapper.classList.contains('pdp-fully-expanded');
    }

    function commit(shouldShow) {
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (scrollButton) scrollButton.tabIndex = shouldShow ? 0 : -1;
    }

    // immediate=true skips the settle debounce below — used for the footer boundary,
    // which should hide/show the instant it crosses the bottom of the screen rather
    // than lagging APPLY_SETTLE_MS behind the scroll. The debounce stays the default
    // for every other caller (ATC section, fully-expanded mutation) since it's there
    // to absorb genuine spurious signals (focus/scroll disturbance around cart-drawer
    // open/close, boundary jitter on a fast sustained scroll — see this file's memory).
    function apply(immediate) {
      var shouldShow = isMobile() && isFullyExpanded() && !sectionVisible && !footerVisible &&
        !isKiwiModalOpen() && !isPdpSidebarOpen();
        console.log(shouldShow,"shouldShowshouldShow")
      clearTimeout(applyTimer);
      if (immediate) {
        commit(shouldShow);
        return;
      }
      applyTimer = setTimeout(function () {
        if (scrollButton) scrollButton.tabIndex = shouldShow ? 0 : -1;
        commit(shouldShow);
      }, APPLY_SETTLE_MS);
    }

    function setupObservers() {
      if (atcObserver) atcObserver.disconnect();
      if (atcClearObserver) atcClearObserver.disconnect();
      var topMargin = isMobile() ? getHeaderOffset() : 0;

      // Bottom margin is 0, not bar.offsetHeight — the real Add to Cart section should
      // during a scroll, not only once it has climbed clear of the bar's own height.
      // Waiting for that used to leave the floating bar sitting there, still covering
      // the real button as it rose up underneath it, for however long that climb took.
      atcObserver = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting) {
          console.log("sectionVisible = true; apply(true);")
          sectionVisible = true;
          apply(true);
        }
      }, { threshold: 0, rootMargin: shrinkMargin(topMargin, 0) });
      atcObserver.observe(scrollTarget);

      atcClearObserver = new IntersectionObserver(function (entries) {
        console.log(entries[entries.length - 1].isIntersecting,"entries[entries.length - 1].isIntersecting")
        if (!entries[entries.length - 1].isIntersecting) {
          console.log("sectionVisible = false; apply();")
          sectionVisible = false;
          apply();
        }
      }, { threshold: 0 });
      atcClearObserver.observe(scrollTarget);
    }

    // The footer starts right where #MainContent's own border-bottom is (the footer
    // group renders immediately after </main>, no gap) — but going through the footer
    // element as a stand-in was one layer of indirection too many and drifted out of
    // sync with it in practice. Read #MainContent's own edge against the viewport
    // directly instead: nothing to get out of sync with.
    function updateFooterVisible() {
      if (!mainContent) return;
      var bottom = mainContent.getBoundingClientRect().bottom;
      var viewportBottom = window.innerHeight;
      if (bottom < viewportBottom && !footerVisible) {
        footerVisible = true;
        apply(true);
      } else if (bottom >= viewportBottom && footerVisible) {
        footerVisible = false;
        apply(true);
      }
    }

    function scheduleFooterCheck() {
      if (footerRafId) return;
      footerRafId = requestAnimationFrame(function () {
        footerRafId = null;
        updateFooterVisible();
      });
    }

    setupObservers();
    updateFooterVisible();
    window.addEventListener('scroll', scheduleFooterCheck, { passive: true });
    window.addEventListener('resize', scheduleFooterCheck, { passive: true });
    if (infoWrapper) {
      var expandObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') {
            apply();
            return;
          }
        }
      });
      expandObserver.observe(infoWrapper, { attributes: true, attributeFilter: ['class'] });
    }
    var resizeDebounceTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeDebounceTimer);
      resizeDebounceTimer = window.setTimeout(setupObservers, 200);
    }, { passive: true });

    function scrollToExpandedPanel() {
      if (typeof window._parallaxScrollToExpanded === 'function') {
        window._parallaxScrollToExpanded();
        return;
      }
      // Land where the info panel starts (right after the gallery), not at the
      // ATC button buried further down inside it — the bar's job is to get the
      // user off the full-height gallery and into the product info, same as
      // scrolling past the gallery manually would. Flush against the header, no
      // breathing-room gap — a gap here just leaves a sliver of gallery image
      // showing above the info panel instead of it touching the top.
      var scrollToEl = infoWrapper || scrollTarget;
      var top = scrollToEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

      // Force the header visible for the duration of this jump, same pattern
      // used elsewhere for a JS-driven scroll (Kiwi modal, size popup): a long
      // smooth scrollTo fires many native scroll events, and sticky-header.js's
      // own up/down heuristics on those (built for real finger-driven scrolling)
      // can still land on "hide" for one of them mid-animation, leaving the
      // header hidden once the jump settles even though the user is headed
      // toward the top of the page, not away from it.
      var hEl = document.querySelector('sticky-header');
      if (hEl) {
        hEl.preventHide = true;
        if (typeof hEl.reveal === 'function') hEl.reveal();
        var releaseHeader = function () {
          hEl.preventHide = false;
        };
        if ('onscrollend' in window) {
          window.addEventListener('scrollend', releaseHeader, { once: true });
        } else {
          setTimeout(releaseHeader, 600);
        }
      }

      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    if (scrollButton) {
      scrollButton.addEventListener('click', scrollToExpandedPanel);
    }

    if (swatchOverflowButton) {
      // The "+N" overflow count sits right next to the ATC button in this same
      // bar — tapping it should jump the user to the product info the same way
      // the button does, not fall through to product-swatches.liquid's generic
      // document-level ".swatch-mobile-overflow" handler (which looks up an
      // unrelated active swatch elsewhere on the page and, on this template,
      // has no parallax bar to toggle). stopPropagation keeps that delegated
      // handler from also firing for this click.
      swatchOverflowButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToExpandedPanel();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
